import { ref } from 'vue'

const message = ref('')
const visible = ref(false)
let timer = null

function show(msg, duration = 2800) {
  message.value = msg
  visible.value = true
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => {
    visible.value = false
    timer = null
  }, duration)
}

function hide() {
  visible.value = false
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
}

export function useToast() {
  return { message, visible, show, hide }
}
